var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                staticClass: "btn-info btn--bigger",
                on: { click: _vm.consultar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _c("span", [_vm._v("Consultar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-success btn--bigger",
                on: { click: _vm.exportar }
              },
              [
                _c("i", { staticClass: "fa fa-file-excel-o" }),
                _c("span", [_vm._v("Exportar")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c(
                "div",
                {
                  staticClass: "form-field select2",
                  class: {
                    "select2--disabled": _vm.bodegas.length == 1
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          options: _vm.bodegas,
                          label: "descripcion",
                          placeholder: "Seleccione..."
                        },
                        on: { input: _vm.inputBodega },
                        model: {
                          value: _vm.selectedBodega,
                          callback: function($$v) {
                            _vm.selectedBodega = $$v
                          },
                          expression: "selectedBodega"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "bodegas" } }, [
                        _vm._v("Sucursal")
                      ])
                    ],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field select2" }, [
                _c(
                  "div",
                  { staticClass: "select2-field" },
                  [
                    _c("v-select", {
                      attrs: {
                        placeholder: "Seleccione...",
                        id: "vendedor_id",
                        options: _vm.vendedores,
                        label: "descripcion"
                      },
                      on: {
                        input: _vm.inputVendedor,
                        search: _vm.searchVendedores
                      },
                      model: {
                        value: _vm.selectedVendedor,
                        callback: function($$v) {
                          _vm.selectedVendedor = $$v
                        },
                        expression: "selectedVendedor"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "vendedor_id" } }, [
                      _vm._v("Vendedor")
                    ])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field select" }, [
                _c("div", { staticClass: "select-field" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.tipo_fecha,
                          expression: "form.tipo_fecha"
                        }
                      ],
                      attrs: { name: "tipo_fecha", id: "tipo_fecha" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.form,
                            "tipo_fecha",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "H" } }, [_vm._v("Hoy")]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "A" } }, [_vm._v("Ayer")]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "P" } }, [
                        _vm._v("Personalizada")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "fecha" } }, [_vm._v("Fecha")])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.tipo_fecha === "P",
                    expression: "form.tipo_fecha === 'P'"
                  }
                ],
                staticClass: "col-xs-12 col-md-4"
              },
              [
                _c("div", { staticClass: "form-field" }, [
                  _c(
                    "div",
                    { staticClass: "datepicker-field" },
                    [
                      _c("VueCtkDateTimePicker", {
                        attrs: {
                          id: "desde",
                          locale: "es",
                          "only-date": "",
                          "no-label": "",
                          "button-now-translation": "Ahora",
                          format: "YYYY-MM-DD",
                          formatted: "YYYY-MM-DD",
                          label: "Seleccione fecha..."
                        },
                        model: {
                          value: _vm.form.desde,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "desde", $$v)
                          },
                          expression: "form.desde"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", [_vm._v("Desde")])
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.tipo_fecha === "P",
                    expression: "form.tipo_fecha === 'P'"
                  }
                ],
                staticClass: "col-xs-12 col-md-4"
              },
              [
                _c("div", { staticClass: "form-field" }, [
                  _c(
                    "div",
                    { staticClass: "datepicker-field" },
                    [
                      _c("VueCtkDateTimePicker", {
                        attrs: {
                          id: "hasta",
                          locale: "es",
                          "only-date": "",
                          "no-label": "",
                          "button-now-translation": "Ahora",
                          format: "YYYY-MM-DD",
                          formatted: "YYYY-MM-DD",
                          label: "Seleccione fecha..."
                        },
                        model: {
                          value: _vm.form.hasta,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "hasta", $$v)
                          },
                          expression: "form.hasta"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", [_vm._v("Hasta")])
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-xs-12" },
              [
                _c("k-table", {
                  ref: "roles",
                  attrs: {
                    buttons: _vm.buttons,
                    buscarButton: false,
                    filterStatus: false,
                    deleteButton: false,
                    createButton: false,
                    editButton: false,
                    params: _vm.form,
                    path: _vm.path,
                    columns: [
                      {
                        display: "Sucursal",
                        value: "bodega.descripcion"
                      },
                      {
                        display: "Número de documento",
                        value: "numero_documento"
                      },
                      {
                        display: "Vendedor",
                        value: "supervisor.descripcion"
                      },
                      {
                        display: "Fecha de liquidación",
                        value: "fecha_liquidacion"
                      },
                      {
                        display: "Nuevas",
                        value: "ventas_nuevas"
                      },
                      {
                        display: "Pendientes",
                        value: "ventas_pendientes"
                      },
                      {
                        display: "Ventas totales",
                        value: "ventas_totales"
                      },
                      {
                        display: "Canceladas",
                        value: "canceladas"
                      },
                      {
                        display: "Total de comisiones",
                        value: "total_comisiones",
                        numeric: false
                      },
                      {
                        display: "Total de descuentos",
                        value: "total_gastos",
                        numeric: false
                      },
                      {
                        display: "Liquido a recibir",
                        value: "liquido_recibir",
                        numeric: false
                      }
                    ]
                  },
                  on: {
                    pagar: _vm.pagar,
                    referir: _vm.referir,
                    anular: _vm.anular,
                    imprimirExcel: _vm.imprimirExcel,
                    imprimir: _vm.imprimir
                  }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            height: "auto",
            width: "70%",
            name: "referirTarjetas",
            scrollable: "",
            reset: "",
            adaptive: "",
            resizable: ""
          }
        },
        [
          _c("referir-tarjetas", {
            attrs: {
              valor_referido: _vm.valor_referido,
              liquidacionId: _vm.selectedLiquidacionId,
              supervisor_id: _vm.selectedVendedorId
            },
            on: {
              cerrar: function($event) {
                return _vm.$modal.hide("referirTarjetas")
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Consulta de Liquidaciones de Venta")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información de la consulta")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Resultados de la Consulta")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-704ef741", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-704ef741","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/nomina/ConsultaLiquidacionesVenta.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-704ef741","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/nomina/ConsultaLiquidacionesVenta.vue
// module chunks = 0